module.exports = __webpack_public_path__ + "static/assets/0eec4e57a1de782fcc4605f6d363b601.png";